import ContactForm from "./ContactForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarker,
  faPhone,
  faEnvelope,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

const iconStyle = {
  color: "#074284",
  fontSize: "18px",
};

const ContactDetail = () => {
  return (
    <section>
      <div className="container">
        <div className="row my-4">
          <div className="col-md-6">
            <h3 className="site_h1 site_h3 mb-4">Contact Details</h3>
            <div className="icon-block d-flex justify-content-start">
              <div>
                <div className="icon-wrap">
                  <FontAwesomeIcon icon={faMapMarker} style={iconStyle} />
                </div>
              </div>
              <div className="icon-content mx-4">
                <h4>Address:</h4>
                <p>
                  Near 5 No.Bus Stop, Main Ferozpur Road, Kahna Nau, Lahore,
                  Pakistan
                </p>
              </div>
            </div>
            <div className="icon-block d-flex justify-content-start">
              <div>
                <div className="icon-wrap">
                  <FontAwesomeIcon icon={faPhone} style={iconStyle} />
                </div>
              </div>
              <div className="icon-content mx-4">
                <h4>Phone:</h4>
                <p>0300-4516820</p>
              </div>
            </div>
            <div className="icon-block d-flex justify-content-start">
              <div>
                <div className="icon-wrap">
                  <FontAwesomeIcon icon={faEnvelope} style={iconStyle} />
                </div>
              </div>
              <div className="icon-content mx-4">
                <h4>Email:</h4>
                <p>ch_imtiazali@yahoo.com</p>
              </div>
            </div>
            <div className="icon-block d-flex justify-content-start">
              <div>
                <div className="icon-wrap">
                  <FontAwesomeIcon icon={faClock} style={iconStyle} />
                </div>
              </div>
              <div className="icon-content mx-4">
                <h4>Mon - Sun:</h4>
                <p>09 AM - 09 PM</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactDetail;
